/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum scopeEnum {
    USER = 'user',
    GLOBAL = 'global',
    TEAM = 'team',
    CEN = 'cen',
}